import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { useCallback, useEffect } from "react";
import { useAsyncDataStatus } from "./useAsyncDataStatus";
import { useSelfServeContext } from "./useSelfServeContext";
/**
 * Calls the async functions to fetch the additional data required by the instant answer;
 * those functions are defined in the additionalRequiredData field of the instant answer.
 */
export var useInstantAnswerContextAdditionalData = function useInstantAnswerContextAdditionalData(instantAnswer) {
  var _useSelfServeContext = useSelfServeContext(),
    context = _useSelfServeContext.context;
  var _useContextAdditional = useContextAdditionalDataState(),
    contextAdditionalData = _useContextAdditional.contextAdditionalData,
    updateContextAdditionalData = _useContextAdditional.updateContextAdditionalData;
  var _useAsyncDataStatus = useAsyncDataStatus(),
    asyncDataInProgress = _useAsyncDataStatus.asyncDataInProgress,
    asyncDataComplete = _useAsyncDataStatus.asyncDataComplete,
    setAsInProgress = _useAsyncDataStatus.setAsInProgress,
    setAsComplete = _useAsyncDataStatus.setAsComplete;
  useEffect(function () {
    if (asyncDataInProgress || asyncDataComplete) {
      return;
    }
    if (!instantAnswer || !instantAnswer.additionalRequiredData) {
      setAsComplete();
      return;
    }
    setAsInProgress();
    invokeAdditionalDataFns(instantAnswer, context).then(updateContextAdditionalData).then(setAsComplete);
  }, [asyncDataComplete, asyncDataInProgress, setAsComplete, setAsInProgress, instantAnswer, context, updateContextAdditionalData]);
  return {
    instantAnswerContextAdditionalData: contextAdditionalData,
    asyncDataComplete: asyncDataComplete
  };
};
var useContextAdditionalDataState = function useContextAdditionalDataState() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    contextAdditionalData = _useState2[0],
    setContextAdditionalData = _useState2[1];
  var updateContextAdditionalData = useCallback(function (responses) {
    setContextAdditionalData(function () {
      return collectAdditionalData(responses);
    });
  }, []);
  return {
    contextAdditionalData: contextAdditionalData,
    updateContextAdditionalData: updateContextAdditionalData
  };
};
var collectAdditionalData = function collectAdditionalData(responses) {
  return responses.reduce(function (additionalData, _ref) {
    var field = _ref.field,
      data = _ref.data;
    return _objectSpread(_objectSpread({}, additionalData), {}, _defineProperty({}, field, data));
  }, {});
};
var invokeAdditionalDataFns = function invokeAdditionalDataFns(instantAnswer, context) {
  if (!instantAnswer.additionalRequiredData) {
    return Promise.resolve([]);
  }
  var allPromises = instantAnswer.additionalRequiredData.map(function (dataFetcherFn) {
    return dataFetcherFn(context);
  });
  return Promise.all(allPromises);
};